function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.7318 4.8199C22.9777 7.00535 23.0268 10.5977 20.8413 12.8436C19.3766 14.3488 17.28 14.8673 15.3802 14.3876L8.91522 21.0315C7.82249 22.1545 6.02632 22.179 4.90336 21.0862C3.7804 19.9935 3.75589 18.1973 4.84862 17.0744L11.3137 10.4305C10.7824 8.54455 11.2434 6.43458 12.7081 4.92938C14.8936 2.68346 18.4859 2.63444 20.7318 4.8199ZM22.0291 6.74106C21.7428 6.03873 21.3101 5.38268 20.7318 4.81992C20.1534 4.25711 19.4857 3.84249 18.7758 3.57542L15.148 7.30353L18.4013 10.4692L22.0291 6.74106Z",
  fill: "currentColor"
});

function SvgMechanic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanic);
export default __webpack_public_path__ + "static/media/mechanic.b208c7fe.svg";
export { ForwardRef as ReactComponent };